'use client'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { Statistics } from '../../lib'
import { GetProjectStatistics } from '@/shared/api/end-points/project'

const useHook = (params: GetProjectStatistics) => {
  const queryKey = [queryKeys((a, m, p) => a.project.getStatistics(params) + m.get)]
  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.getStatistics(params)),
  })

  return {
    ...query,
    queryKey,
  } as UseQueryResult<Statistics> & { queryKey: typeof queryKey }
}
export default useHook
